import domready from "domready";
import "../elements/navigation--viewport";
domready(function () {
  var topBar = document.querySelector(".top-bar");
  if (topBar) {
    var topBarHeight = topBar.offsetHeight;
    var navigationMain = document.querySelector(".navigation--main");
    var header = document.querySelector(".header");
    var scrollPosition = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
    var stickyTopBar = function (entries) {
      if (!entries[0].isIntersecting) {
        topBar.classList.add("top-bar--fixed");
        if (navigationMain) {
          navigationMain.classList.add("navigation--fixed");
        }
      } else {
        topBar.classList.remove("top-bar--fixed");
        if (navigationMain) {
          navigationMain.classList.remove("navigation--fixed");
        }
      }
    };
    var observer = new window.IntersectionObserver(stickyTopBar);
    if (header) {
      topBarClasses(scrollPosition);
      observer.observe(header);
    } else {
      topBar.classList.add("top-bar--fixed");
      if (navigationMain) {
        navigationMain.classList.add("navigation--fixed");
      }
    }
    function topBarClasses(scrollPosition) {
      if (header.offsetHeight > topBarHeight) {
        if (scrollPosition > header.offsetHeight - topBarHeight) {
          topBar.classList.add("top-bar--fixed");
          if (navigationMain) {
            navigationMain.classList.add("navigation--fixed");
          }
        } else {
          topBar.classList.remove("top-bar--fixed");
          if (navigationMain) {
            navigationMain.classList.remove("navigation--fixed");
          }
        }
      } else {
        topBar.classList.remove("top-bar--fixed");
        if (navigationMain) {
          navigationMain.classList.remove("navigation--fixed");
        }
      }
    }
  }
});
